import { z } from "zod/v4";

import { ShopifyPageSchema } from "../../../schemas/shopify";

export const GetShopPagesResponseBodySchema = z.object({
  pages: ShopifyPageSchema.array(),
});
export type GetShopPagesResponseBodyType = z.infer<
  typeof GetShopPagesResponseBodySchema
>;
